import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../useSite';
import { Seo } from '../components/Seo';
import { Container } from '../components/Primitives';
import { PageHero } from '../components/Sections';
import { TestimonialForm } from '../components/TestimonialForm';

export const GOOGLE_REVIEW_URL = '';

export default function ReviewPage() {
  const { t, p } = useSite();
  const r = t.review;
  return (
    <>
      <Seo title={t.seo.review.title} description={t.seo.review.description} noindex />
      <PageHero overline={r.overline} title={r.h1} intro={r.intro} />
      <section className="bg-white pb-20 md:pb-24" data-testid="review-page">
        <Container>
          <TestimonialForm className="pt-16 md:pt-20" />
          <div className="mt-8 grid gap-10 md:grid-cols-12">
            <p className="text-xs leading-relaxed text-cafe-noir/60 md:col-span-8 md:col-start-5" data-testid="review-privacy-note">
              {r.privacy}{' '}
              <Link to={p('privacy')} className="underline underline-offset-2 hover:text-kombu-green" data-testid="review-privacy-link">{t.legal.privacy.h1}</Link>.
            </p>
          </div>
          {GOOGLE_REVIEW_URL && (
            <div className="mt-16 flex flex-col gap-5 border-t border-tan/50 pt-12 md:flex-row md:items-center md:justify-between" data-testid="google-review-block">
              <div>
                <h2 className="font-serif text-2xl text-kombu-green">{r.googleTitle}</h2>
                <p className="mt-2 text-sm text-cafe-noir/70">{r.googleText}</p>
              </div>
              <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer" data-testid="google-review-link"
                className="inline-flex shrink-0 items-center justify-center rounded-[2px] border border-kombu-green px-6 py-3.5 text-sm font-semibold text-kombu-green transition-colors hover:bg-kombu-green hover:text-bone-light">
                {r.googleCta}
              </a>
            </div>
          )}
        </Container>
      </section>
    </>
  );
}

export const ReviewRedirect = () => {
  React.useEffect(() => {
    const es = (navigator.languages || [navigator.language || '']).some((l) => l && l.toLowerCase().startsWith('es'));
    window.location.replace(es ? '/es/review/' : '/en/review/');
  }, []);
  return null;
};
